import endpoints from '../modules/ajio-util/endpoints';
import { getPlaAdsClientID } from '../refresh/selectors/featureFlagsSelector';
import { signInCheck } from '../components/common/CheckUserStatus';
import { readCookie } from '../components/common/Cookie';
import { sha256Hex } from './products';
import { isMobile } from '../refresh/utils/deviceTypeUtils';
import { getAmplitudeExperimentVariant, getAmplitudeVariantPayload } from './amplitudeCommon';

export const fireOsmosPlpImpression = ({
  uclid,
  position = 0,
  page = '',
  clientId=''
}) => {
  try {
    const pageTypeOsmos = page === 'orderListing' ? 'orderList' : page === "thankyou" ? 'thankYou' : page === 'home screen' ? 'home' : page;
    const enablePlaOnPDP = getAmplitudeExperimentVariant('enable-pla-on-pdp-osmos', window?.__PRELOADED_STATE__);
    const enablePlaOnPLP = getAmplitudeExperimentVariant('enable-pla-on-plp-osmos', window?.__PRELOADED_STATE__);
    const osmosBannerConfig = getAmplitudeVariantPayload('osmos_banner_ads', window?.__PRELOADED_STATE__ , {});
    const osmosSpecs = getAmplitudeVariantPayload('osmosadsspecs', window?.__PRELOADED_STATE__ , {});
    const isOsmosEnable = osmosBannerConfig?.[pageTypeOsmos]?.isEnabled || false;
    const osmosClientId = osmosSpecs?.clientId || '';

    if ((page === 'PDP' && !enablePlaOnPDP) || (page === 'PLP' && !enablePlaOnPLP)) {
      return;
    }
    if (!uclid) {
      console.log('OSMOS PLP impression: Missing required parameters (uclid or client_id)');
      return;
    }
    const baseImpressionUrl = new URL(endpoints.get('osmosImpressionTracker'));

    if (!baseImpressionUrl) {
      console.error('OSMOS PLP impression: No impression URL available');
      return;
    }

    const impressionTrackerUrl = new URL(baseImpressionUrl);

    const cliUbid = signInCheck()
      ? sha256Hex(readCookie('CI')) || ''
      : sha256Hex(readCookie('segment_device_id')) || '';

    const eventTime = Date.now();

    const paramsToAdd = {
      client_id: clientId || getPlaAdsClientID(window?.__PRELOADED_STATE__) || isOsmosEnable ? osmosClientId : '',
      uclid: uclid || '',
      cli_ubid: cliUbid || '',
      position: position !== undefined ? position : 0,
      os_version: '',
      os_name: isMobile() ? 'm_web' : 'Desktop',
      event_time: eventTime.toString(),
    };

    Object.entries(paramsToAdd).forEach(([key, value]) => {
      if (value !== undefined && value !== '') {
        impressionTrackerUrl.searchParams.set(key, value);
      }
    });

    fetch(impressionTrackerUrl.toString(), {
        method: 'POST',
        headers: {
          accept: 'application/json'
        }
      })
      .then(() => {
        console.log('OSMOS PLP product impression tracker fired successfully 🚀');
      })
      .catch(err => {
        console.error('OSMOS PLP product impression tracker failed', err);
      });
  } catch (error) {
    console.error('OSMOS PLP impression: Error firing impression tracker', error);
  }
}
export const fireOsmosClickTracker = (uclid, page = '', clientId='') => {
  try {
    const pageTypeOsmos = page === 'orderListing' ? 'orderList' : page === "thankyou" ? 'thankYou' : page === 'home screen' ? 'home' : page;
    const enablePlaOnPDP = getAmplitudeExperimentVariant('enable-pla-on-pdp-osmos', window?.__PRELOADED_STATE__);
    const enablePlaOnPLP = getAmplitudeExperimentVariant('enable-pla-on-plp-osmos', window?.__PRELOADED_STATE__);
    const osmosBannerConfig = getAmplitudeVariantPayload('osmos_banner_ads', window?.__PRELOADED_STATE__ , {});
    const osmosSpecs = getAmplitudeVariantPayload('osmosadsspecs', window?.__PRELOADED_STATE__ , {});
    const isOsmosEnable = osmosBannerConfig?.[pageTypeOsmos]?.isEnabled || false;
    const osmosClientId = osmosSpecs?.clientId || '';


    if ((page === 'PDP' && !enablePlaOnPDP) || (page === 'PLP' && !enablePlaOnPLP )) {
      return;
    }
    if (!uclid) return;

    const client_id = clientId || getPlaAdsClientID(window?.__PRELOADED_STATE__) || isOsmosEnable ? osmosClientId : '';

    const event_time = Date.now().toString();
    const cli_ubid = signInCheck()
      ? sha256Hex(readCookie('CI')) || ''
      : sha256Hex(readCookie('segment_device_id')) || '';

    const clickTrackerUrl = new URL(endpoints.get('osmosClickTracker'));
    const paramsToAdd = { client_id, cli_ubid, uclid, event_time };
    Object.entries(paramsToAdd).forEach(([key, value]) => {
      if (value !== undefined && value !== '') clickTrackerUrl.searchParams.set(key, value);
    });

    fetch(clickTrackerUrl.toString(), {
      method: 'GET',
      headers: {
        accept: 'application/json'
      }
    })
    .then(() => console.log('OSMOS product click tracker fired successfully 🚀'))
    .catch(err => console.log('OSMOS product click tracker failed', err));
  } catch (error) {
    console.log('Error firing OSMOS product click tracker', error);
  }
};
